import { OfferMessage } from '@atomicfinance/bitcoin-dlc-provider';
import {
  Box,
  Button,
  Flex,
  Grid,
  Heading,
  Image,
  Link,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Stat,
  StatLabel,
  StatNumber,
  Text,
  useDisclosure,
} from '@chakra-ui/core';
import { CopyIcon } from '@chakra-ui/icons';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { BeatLoader } from 'react-spinners';
import DesktopImage from '../assets/desktop.svg';
import USAFlagImage from '../assets/usa_flag.png';
import { BidenFace, TrumpFace } from '../components/CandidateFaces';
import CopyComponent from '../components/CopyComponent';
import Header from '../components/Header';
import ResolutionDetailsModal from '../components/ResolutionDetailsModal';
import config from '../config/config';
import { getTowerService } from '../services/towerService';
import { getTwitterInfoById } from '../services/twitter';
import { RootState } from '../store/reducers';
import { round, toBTC } from '../utils/Utils';
import AcceptBet from './AcceptBet';

interface ParamTypes {
  contractUUID: string;
}

const BetPartyCard = (props) => {
  const { heading, image, name, amount, ...rest } = props;

  const btcPrice = useSelector((state: RootState) => state.prices.btcusd);

  const satsToValue = (sats) =>
    round((sats / 100000000) * btcPrice, 2).toFixed(2);

  return (
    <Box
      textAlign="center"
      p={4}
      w="100%"
      backgroundColor="#ffffff"
      borderRadius="8px"
      {...rest}
    >
      <Heading as="h4" size="md">
        {heading}
      </Heading>
      <Image
        boxSize="68px"
        borderRadius="100%"
        margin="0 auto"
        mt={4}
        src={image}
      />
      <Text mt={2}>{name} Deposits</Text>
      <Text>
        <b>{toBTC(amount)} BTC</b>{' '}
        <Text as="span" color="#a0a0a0">
          ${satsToValue(amount)} USD
        </Text>
      </Text>
    </Box>
  );
};

const CounterViewOfferContainer = () => {
  const { contractUUID } = useParams<ParamTypes>();
  const [offer, setOffer] = useState<OfferMessage>(null);
  const [betDetails, setBetDetails] = useState<any>(null);
  const [accepted, setAccepted] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const history = useHistory();

  const [twitterInfo, setTwitterInfo] = useState<any | undefined>();

  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isMobileModalOpen,
    onOpen: onOpenMobileModal,
    onClose: onCloseMobileModal,
  } = useDisclosure();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    (async () => {
      const tower = getTowerService();
      const contractData = await tower.getOffer(contractUUID);
      const twitterId = await tower.findTwitterId(contractUUID);

      let _twitterInfo;
      try {
        _twitterInfo = await getTwitterInfoById(twitterId);
      } catch (e) {
        _twitterInfo = {
          name: 'Unknown',
          profile_image_url_https:
            'https://abs.twimg.com/sticky/default_profile_images/default_profile_400x400.png',
        };
      }

      setTwitterInfo(_twitterInfo);

      setOffer(contractData);
      console.log(contractData);

      const { publishDate } = (
        await axios.get(
          `${config.oracle.url}/asset/rvalue/${contractData.oracleInfo.rValue}`
        )
      ).data;

      const betSize =
        contractData.localCollateral.GetSatoshiAmount() +
        contractData.remoteCollateral.GetSatoshiAmount();
      const betAmount = contractData.remoteCollateral.GetSatoshiAmount();
      const betAmountCounter = contractData.localCollateral.GetSatoshiAmount();
      const prediction = contractData.outcomes[1].message;

      const betDetails = {
        event: 'election',
        prediction,
        resolutionDate: publishDate,
        betSize,
        betAmount,
        betAmountCounter,
      };

      setBetDetails(betDetails);

      const _isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      setIsMobile(_isMobile);

      if (localStorage.getItem('encryptedMnemonic')) {
        setIsLoggedIn(true);
      }
    })();
  }, [contractUUID]);

  if (!offer || !betDetails)
    return (
      <Flex justifyContent="center" alignItems="center" boxSize="full">
        <BeatLoader />
      </Flex>
    );

  if (accepted && betDetails)
    return (
      <AcceptBet
        betDetails={betDetails}
        offer={offer}
        setAccepted={setAccepted}
        name={twitterInfo?.name.split(' ')[0]}
      />
    );

  const localPrediction =
    betDetails.prediction === 'democratic' ? 'Republican' : 'Democratic';
  const remotePrediction =
    betDetails.prediction === 'democratic' ? 'Democratic' : 'Republican';

  return (
    <Box w="100%" minW="1000px">
      <Modal
        isOpen={isMobileModalOpen}
        onClose={onCloseMobileModal}
        size="xl"
        isCentered
      >
        <ModalOverlay>
          <ModalContent textAlign="center" p={4}>
            <ModalHeader>Desktop Preferred</ModalHeader>
            <ModalCloseButton />
            <ModalBody textAlign="center">
              <Image src={DesktopImage} mx="auto" mb={4} />
              <Text fontSize="sm">
                For the best experience, we recommend continuing on a desktop
                computer.
              </Text>
              <br />
              <Button onClick={() => setAccepted(true)}>
                Continue Anyways
              </Button>
            </ModalBody>
          </ModalContent>
        </ModalOverlay>
      </Modal>
      <ResolutionDetailsModal
        isOpen={isOpen}
        onOpen={onOpen}
        onClose={onClose}
      />
      <Header
        h="180px"
        w="100%"
        backgroundColor="#42486b"
        alignItems="center"
        justifyContent="center"
      >
        <Heading color="white" size="lg" textAlign="center">
          US Presidential Election on November 3rd 2020
        </Heading>

        {isLoggedIn && (
          <Button
            bg="white"
            color="blue.600"
            borderColor="blue.600"
            borderWidth="1px"
            position="absolute"
            top="5"
            right="330px"
            size="sm"
            colorScheme="white"
            onClick={() => history.push(`/dashboard`)}
          >
            Go to Dashboard
          </Button>
        )}

        <CopyComponent copyValue={window.location}>
          <Button
            bg="white"
            color="blue.600"
            borderColor="blue.600"
            borderWidth="1px"
            position="absolute"
            top="5"
            right="170px"
            size="sm"
            colorScheme="white"
            rightIcon={<CopyIcon />}
          >
            Copy Offer Link
          </Button>
        </CopyComponent>

        <Button
          bg="white"
          color="blue.600"
          borderColor="blue.600"
          borderWidth="1px"
          position="absolute"
          top="5"
          right="5"
          size="sm"
          colorScheme="white"
          onClick={() =>
            history.push(
              `/offers/${twitterInfo?.screen_name || 'pierre_rochard'}`
            )
          }
        >
          View Open Offers
        </Button>
      </Header>
      <Box margin="0 auto" p={16} w="fit-content">
        <Grid
          gridTemplateRows="1fr 200px 60px"
          gridTemplateColumns="1.2fr 0.7fr 1.2fr"
          gridTemplateAreas='"t1 t2 t3" "lp cn rp" "lb . rb"'
          w="100%"
          maxWidth="1600px"
          gap="10px"
        >
          <BidenFace
            h="120px"
            gridArea={localPrediction === 'Democratic' ? 't1' : 't3'}
            direction={localPrediction === 'Democratic' ? 'right' : 'left'}
            justifySelf="center"
            // justifySelf={localPrediction === 'Democratic' ? 'start' : 'end'}
          />
          <Box gridArea="t2" justifySelf="center" textAlign="center">
            <Image src={USAFlagImage} h="100px" mb={2} mx="Auto" />
            <Text fontWeight="500">Resolution Details</Text>
            <Text
              fontWeight="500"
              fontSize="sm"
              color="blue.600"
              textDecor="underline"
              onClick={onOpen}
              cursor="pointer"
            >
              View Details
            </Text>
          </Box>

          <TrumpFace
            h="120px"
            gridArea={localPrediction === 'Democratic' ? 't3' : 't1'}
            direction={localPrediction === 'Democratic' ? 'left' : 'right'}
            justifySelf="center"
            // justifySelf={localPrediction === 'Democratic' ? 'end' : 'start'}
          />
          <BetPartyCard
            gridArea="lp"
            heading={`${localPrediction} Party Wins`}
            name={twitterInfo.name}
            image={twitterInfo?.profile_image_url_https?.replace(
              'normal',
              '200x200'
            )}
            amount={offer.localCollateral.GetSatoshiAmount()}
          />
          <Flex
            textAlign="center"
            alignItems="center"
            justifyContent="center"
            gridArea="cn"
          >
            <Stat>
              <StatLabel>Total Bet Size</StatLabel>
              <StatNumber>
                {toBTC(
                  offer.localCollateral.GetSatoshiAmount() +
                    offer.remoteCollateral.GetSatoshiAmount()
                )}{' '}
                BTC
              </StatNumber>
            </Stat>
          </Flex>
          <BetPartyCard
            gridArea="rp"
            heading={`${remotePrediction} Party Wins`}
            name="Counterparty"
            image="https://www.netclipart.com/pp/m/147-1479847_icone-contact-png-user-silhouette-icon.png"
            amount={offer.remoteCollateral.GetSatoshiAmount()}
          />
          <Button
            h="100%"
            gridArea="lb"
            whiteSpace="normal"
            backgroundColor="#707070"
            color="white"
          >
            {twitterInfo?.name.split(' ')[0]} is putting his Bitcoin where their
            mouth is
          </Button>
          <></>
          <Box position="relative" gridArea="rb" textAlign="center">
            <Button
              h="100%"
              w="100%"
              whiteSpace="normal"
              colorScheme="blue"
              color="white"
              disabled={
                !!localStorage.getItem(contractUUID) ||
                offer.contractStage !== 'OFFER'
              }
              onClick={() => {
                if (isMobile) {
                  onOpenMobileModal();
                } else {
                  setAccepted(true);
                }
              }}
            >
              {offer.contractStage === 'OFFER'
                ? 'Join as counterparty'
                : 'Offer already accepted.'}
            </Button>
            <Text fontSize="xs" position="absolute" bottom="-40px">
              By proceeding, you accept our{' '}
              <Link
                color="blue.600"
                target="_blank"
                href="/odds/app/BetaTermsOfService.html"
              >
                Beta Terms of Service
              </Link>
              ,{' '}
              <Link
                color="blue.600"
                target="_blank"
                href="/odds/app/TermsOfService.html"
              >
                Terms of Service
              </Link>
              , and{' '}
              <Link
                color="blue.600"
                target="_blank"
                href="/odds/app/PrivacyPolicy.html"
              >
                Privacy Policy
              </Link>
            </Text>
          </Box>
        </Grid>
      </Box>
    </Box>
  );
};

export default CounterViewOfferContainer;
